module.exports = __webpack_public_path__ + "img/image-01.00d119db.jpeg";